import AuthLoginModal from "@/components/auth/modals/AuthLoginModal";
import AuthLoginWithCodeModal from "@/components/auth/modals/AuthLoginWithCodeModal";
import AuthModalWrap from "@/components/auth/modals/AuthModalWrap";
import AuthPasswordModal from "@/components/auth/modals/AuthPasswordModal";
import AuthSessionsModal from "@/components/auth/modals/AuthSessionsModal";
import AuthWithCodeModal from "@/components/auth/modals/AuthWithCodeModal";
import ChangePassword from "@/components/staff/modals/ChangePassword";
import DeleteAccountCodeModal from "@/components/staff/modals/DeleteAccountCodeModal";
import DeleteAccountModal from "@/components/staff/modals/DeleteAccountModal";
import ForgotPasswordCode from "@/components/staff/modals/ForgotPasswordModal/ForgotPasswordCode";
import ForgotPasswordLogin from "@/components/staff/modals/ForgotPasswordModal/ForgotPasswordLogin";
import ForgotPasswordSetNew from "@/components/staff/modals/ForgotPasswordModal/ForgotPasswordSetNew";
import ForgotPasswordSuccess from "@/components/staff/modals/ForgotPasswordModal/ForgotPasswordSuccess";
import ForgotPasswordWrap from "@/components/staff/modals/ForgotPasswordModal/ForgotPasswordWrap";
import OrderMovieModal from "@/components/staff/order-movie/OrderMovieModal";
import TopUpAmountModal from "@/components/staff/payment/modal/TopUpModal/TopUpAmountModal";
import TopUpMethodsModal from "@/components/staff/payment/modal/TopUpModal/TopUpMethodsModal";
import TopUpWrap from "@/components/staff/payment/modal/TopUpModal/TopUpWrap";
import AddSessionModal from "@/components/staff/sessions/modals/AddSessionModal";
import EndAllSessionsModal from "@/components/staff/sessions/modals/EndAllSessionsModal";
import SessionDeviceModal from "@/components/staff/sessions/modals/SessionDeviceModal";

import AutoPaymentModal from "../AutoPaymentModal";
import BuySubscriptionMethodsModal from "../BuySubscriptionModal/BuySubscriptionMethodsModal";
import BuySubscriptionPricesModal from "../BuySubscriptionModal/BuySubscriptionPricesModal";
import BuySubscriptionWrap from "../BuySubscriptionModal/BuySubscriptionWrap";
import CancelSubscriptionModal from "../CancelSubscriptionModal";
import CreditCardAddModal from "../CreditCardModal/CreditCardAddModal";
import CreditCardModalWrap from "../CreditCardModal/CreditCardModalWrap";
import CreditCardOtpModal from "../CreditCardModal/CreditCardOtpModal";
import OrderPerformSuccessModal from "../OrderPerformSuccessModal";
import PaymentFailModal from "../PaymentFailModal";
import ProfilePinModal from "../ProfilePinModal";
import UserInfoModal from "../UserInfoModal";

export interface IModalRoute {
  name: string;
  bgColor?: string;
  children?: IModalRoute[];
  component: React.ComponentType<{ children?: React.ReactNode }>;
}

export enum MODAL_ROUTES {
  CREDIT_CARD = "credit-card",
  CREDIT_CARD_ADD = "add",
  CREDIT_CARD_OTP = "otp",
  CHANGE_PASSWORD = "change-password",
  FORGOT_PASSWORD = "forgot-password",
  FORGOT_PASSWORD_CODE = "code",
  FORGOT_PASSWORD_LOGIN = "login",
  FORGOT_PASSWORD_SET_NEW = "set-new",
  FORGOT_PASSWORD_SUCCESS = "success",
  DELETE_ACCOUNT = "delete-account",
  DELETE_ACCOUNT_CODE = "delete-account-code",
  ADD_DEVICE = "add-device",
  DELETE_SESSION = "delete-session",
  DELETE_ALL_SESSIONS = "delete-all-sessions",
  BUY_SUBSCRIPTION = "buy-subscription",
  BUY_SUBSCRIPTION_PRICES = "prices",
  BUY_SUBSCRIPTION_METHODS = "methods",
  ORDER_PERFORM_SUCCESS = "order-perform-success",
  ORDER_PERFORM_ERROR = "order-perform-error",
  TOP_UP = "top-up",
  TOP_UP_AMOUNT = "amount",
  TOP_UP_METHODS = "methods",
  CANCEL_SUBSCRIPTION = "cancel-subscription",
  ORDER_MOVIE = "order-movie",
  AUTH = "auth",
  AUTH_LOGIN = "login",
  AUTH_PASSWORD = "password",
  AUTH_SESSIONS = "sessions",
  AUTH_OTP = "otp",
  AUTH_CODE = "code",
  PROFILE_INFO = "profile-info",
  PROFILE_PIN = "profile-pin",
  AUTO_PAYMENT = "auto-payment",
}

const modalRoutes: IModalRoute[] = [
  {
    name: MODAL_ROUTES.CREDIT_CARD,
    component: CreditCardModalWrap,
    children: [
      {
        name: MODAL_ROUTES.CREDIT_CARD_ADD,
        component: CreditCardAddModal,
      },
      {
        name: MODAL_ROUTES.CREDIT_CARD_OTP,
        component: CreditCardOtpModal,
      },
    ],
  },
  {
    name: MODAL_ROUTES.CHANGE_PASSWORD,
    component: ChangePassword,
  },
  {
    name: MODAL_ROUTES.FORGOT_PASSWORD,
    component: ForgotPasswordWrap,
    children: [
      {
        name: MODAL_ROUTES.FORGOT_PASSWORD_LOGIN,
        component: ForgotPasswordLogin,
      },
      {
        name: MODAL_ROUTES.FORGOT_PASSWORD_CODE,
        component: ForgotPasswordCode,
      },
      {
        name: MODAL_ROUTES.FORGOT_PASSWORD_SET_NEW,
        component: ForgotPasswordSetNew,
      },
      {
        name: MODAL_ROUTES.FORGOT_PASSWORD_SUCCESS,
        component: ForgotPasswordSuccess,
      },
    ],
  },
  {
    name: MODAL_ROUTES.DELETE_ACCOUNT,
    component: DeleteAccountModal,
  },
  {
    name: MODAL_ROUTES.DELETE_ACCOUNT_CODE,
    component: DeleteAccountCodeModal,
  },
  {
    name: MODAL_ROUTES.ADD_DEVICE,
    component: AddSessionModal,
  },
  {
    name: MODAL_ROUTES.DELETE_SESSION,
    component: SessionDeviceModal,
  },
  {
    name: MODAL_ROUTES.DELETE_ALL_SESSIONS,
    component: EndAllSessionsModal,
  },
  {
    name: MODAL_ROUTES.BUY_SUBSCRIPTION,
    component: BuySubscriptionWrap,
    children: [
      {
        name: MODAL_ROUTES.BUY_SUBSCRIPTION_PRICES,
        component: BuySubscriptionPricesModal,
      },
      {
        name: MODAL_ROUTES.BUY_SUBSCRIPTION_METHODS,
        component: BuySubscriptionMethodsModal,
      },
    ],
  },
  {
    name: MODAL_ROUTES.ORDER_PERFORM_SUCCESS,
    component: OrderPerformSuccessModal,
  },
  {
    name: MODAL_ROUTES.ORDER_PERFORM_ERROR,
    component: PaymentFailModal,
  },
  {
    name: MODAL_ROUTES.TOP_UP,
    component: TopUpWrap,
    children: [
      {
        name: MODAL_ROUTES.TOP_UP_AMOUNT,
        component: TopUpAmountModal,
      },
      {
        name: MODAL_ROUTES.TOP_UP_METHODS,
        component: TopUpMethodsModal,
      },
    ],
  },
  {
    name: MODAL_ROUTES.CANCEL_SUBSCRIPTION,
    component: CancelSubscriptionModal,
  },
  {
    name: MODAL_ROUTES.ORDER_MOVIE,
    component: OrderMovieModal,
  },
  {
    name: MODAL_ROUTES.AUTH,
    component: AuthModalWrap,
    children: [
      {
        name: MODAL_ROUTES.AUTH_LOGIN,
        component: AuthLoginModal,
      },
      {
        name: MODAL_ROUTES.AUTH_PASSWORD,
        component: AuthPasswordModal,
      },
      {
        name: MODAL_ROUTES.AUTH_SESSIONS,
        component: AuthSessionsModal,
      },
      {
        name: MODAL_ROUTES.AUTH_OTP,
        component: AuthLoginWithCodeModal,
      },
      {
        name: MODAL_ROUTES.AUTH_CODE,
        component: AuthWithCodeModal,
      },
    ],
  },
  {
    name: MODAL_ROUTES.PROFILE_INFO,
    component: UserInfoModal,
  },
  {
    name: MODAL_ROUTES.PROFILE_PIN,
    component: ProfilePinModal,
  },
  {
    name: MODAL_ROUTES.AUTO_PAYMENT,
    component: AutoPaymentModal,
  },
];

export default modalRoutes;
